import { Injectable } from '@angular/core';
import {
  LoginResponseData,
  UsuarioLogado,
} from '../models/usuario-login.model';
import { MontarMenuService } from './montar-menu.service';

@Injectable({
  providedIn: 'root',
})
export class ControleSessaoService {
  private chaveUsuario = 'usuario_logado';
  private chaveToken = 'token_acesso';
  private accessToken: string | null = null;

  constructor(private montarMenuService: MontarMenuService) {
    const stored = sessionStorage.getItem(this.chaveToken);
    this.accessToken = stored ? stored : null;
  }

  // Armazena o usuário no sessionStorage (evita persistir tokens sensíveis)
  armazenaUsuarioSessao(dados: LoginResponseData): void {
    // Não persistir `token_acesso` junto ao objeto do usuário
    const copia = { ...dados, token_acesso: undefined } as any;
    const dadosStr = JSON.stringify(copia);
    sessionStorage.setItem(this.chaveUsuario, dadosStr);

    // Montar menu a partir dos sistemas do usuário
    console.log(
      '[ControleSessaoService] Montando menu a partir dos sistemas...',
    );
    this.montarMenuService.montarMenuAPartirDosistemas(dados);

    // Disparar evento para componentes que dependem do usuário logado (ex: sidebar para fixados)
    window.dispatchEvent(new CustomEvent('usuario-logado'));
  }

  // Recupera o usuário da sessão
  getUsuarioSessao(): LoginResponseData | null {
    const dadosJson = sessionStorage.getItem(this.chaveUsuario);
    return dadosJson ? JSON.parse(dadosJson) : null;
  }

  // Verifica se há um usuário autenticado
  usuarioAutenticado(): boolean {
    const autenticado = !!sessionStorage.getItem(this.chaveUsuario);
    console.log('[ControleSessaoService] Usuário autenticado?', autenticado);
    return autenticado;
  }

  // Remove os dados da sessão
  logoutSessaoUsuario(): void {
    console.log('[ControleSessaoService] Limpando sessão do usuário.');
    sessionStorage.removeItem(this.chaveUsuario);
    sessionStorage.removeItem(this.chaveToken);
    // remover possível armazenamento legado em localStorage (não usado para tokens)
    localStorage.removeItem(this.chaveUsuario);
    this.clearTempToken();
    this.setAccessToken(null);
  }

  // Métodos para manipular um token temporário (ex.: 2FA)
  private tempToken: string | null = null;

  setTempToken(token: string | null): void {
    this.tempToken = token;
  }

  getTempToken(): string | null {
    return this.tempToken;
  }

  clearTempToken(): void {
    this.tempToken = null;
  }

  setAccessToken(token: string | null): void {
    this.accessToken = token || null;
    if (this.accessToken) {
      sessionStorage.setItem(this.chaveToken, this.accessToken);
    } else {
      sessionStorage.removeItem(this.chaveToken);
    }
  }

  getAccessToken(): string | null {
    return this.accessToken;
  }
}
